<template>
    <div class="detail-container">
        <div v-show="data.type-0 === 2" class="changeBg">
            <span>封面图</span>
            <div v-click-outside="closeMethod" :style="'background-image: url('+cover+')'" class="bg">
                <p v-if="!data.isStream" @click="showMethod=!showMethod" :class="{change: true,on: showMethod}">更换</p>
                <ul v-show="showMethod">
                    <li @click="showMethod=false" id="picBtn">本地上传</li>
                    <li @click="maskMaterial">素材库</li>
                </ul>
            </div>
        </div>
        <div class="nameAndTime">
            <div @click="showCard(data.uid, $event)" class="name">
                <i></i>
                <p>{{data.username}}</p>
            </div>
            <div class="time">
                <i></i>
                <p>{{data.raw_add_time}}</p>
            </div>
        </div>
        <div class="line"><p></p></div>
        <ul class="mediaDetail">
            <!-- <li>
                <span>信源</span>
                <p>{{data.source_info && data.source_info.ptitle}}</p>
            </li>
            <li>
                <span>频道</span>
                <p>{{data.source_info && data.source_info.stitle}}</p>
            </li> -->
            <li>
                <span>来源</span>
                <p>{{data.source_info && data.source_info.ptitle}}</p>
                <p v-if="data.source_info && data.source_info.stitle">-{{data.source_info && data.source_info.stitle}}</p>
            </li>
            <li>
                <span>上传来源</span>
                <p>{{data.platform}}</p>
            </li>
            <li v-if="data && data.premiere_date">
                <span>首播日期</span>
                <p>{{data.premiere_date}}</p>
            </li>
            <li class="b" v-if="data && data.use_level && data.use_level.length > 0">
                <span>慎用</span>
                <ul>
                    <li class="alert" v-for="(item,index) in data.use_level" :key="index">{{item}}</li>
                </ul>
            </li>
            <li v-if="data && data.secret_level">
                <span>密级</span>
                <ul>
                    <li>{{data.secret_level}}</li>
                </ul>
            </li>
        </ul>
        <ul class="mediaDetail bg">
            <li>
                <span>格式</span>
                <p>{{data.content && (data.content.format || data.content.type)}}</p>
            </li>
            <li v-if="data.content && data.content.duration">
                <span>时长</span>
                <p>{{data.content && data.content.duration}}</p>
            </li>
            <li v-if="data.content && data.content.rate">
                <span>码率</span>
                <p>{{data.content && data.content.rate}}</p>
            </li>
            <li v-if="data.type == 1 || data.type == 2">
                <span>大小</span>
                <p>{{data.content && (data.content.file_size || data.content.size)}}</p>
            </li>
            <li v-if="data.type == 1">
                <span>高度</span>
                <p>{{data.content && data.content.pixel}}</p>
            </li>
            <li v-if="data.content && data.content.resolution">
                <span>分辨率</span>
                <p>{{data.content && data.content.resolution}}</p>
            </li>
            <li v-if="data.content && data.content.fps">
                <span>帧率</span>
                <p>{{data.content && data.content.fps}}</p>
            </li>
        </ul>
        <ul class="mediaDetail align">
            <li>
                <span>简介</span>
                <p v-if="!editSummary">{{summary || '无'}}<i v-if="canEdit" @click="editSummary = true"></i></p>
                <textarea @blur="editSummary = false;setInfoMaterial()" v-if="editSummary" v-model="summary"></textarea>
                <!-- <span v-if="editSummary" @click="editSummary = false;setInfoMaterial()" class="confirm">确定</span> -->
            </li>
        </ul>
    </div>
</template>

<script>
import common from "@common/common";
import * as config from "@common/config";
import vClickOutside from "v-click-outside";

export default {
    name: 'newMaterialDetail',
    directives: {
        clickOutside: vClickOutside.directive
    },
    data() {
        return {
            file_id: '',
            cover: '',
            showMethod: false,
            editSummary: false,
            summary: '',
            appId: '',
            appSecret: '',
            picStream: null,
            picConfig: {
                browseFileId: 'picBtn',
                extFilters: ['.jpg', '.png', '.gif', '.jpeg'],
                maxSize: 20*1024*1024,
                customered: true,
                autoUploading: true,
                multipleFiles: false,
                retryCount: 3,
                tokenURL: '',
                uploadURL: '',
                postVarsPerFile : {
                    appId: '',
                    appSecret: ''
                },
                onComplete: (f) => {
                const path = (JSON.parse(f.msg)).targetPath

                this.changeAvatar(path)
                },
                onUploadError: (f) => {
                this.$toast('修改头像失败')
                },
                onMaxSizeExceed: (f) => {
                console.log('exceed', f)
                this.$toast('图片不能超过20MB')
                }
            }
        }
    },
    props: {
        newOpen: {
            type: Boolean,
            default: false
        },
        quickEdit: {
            type: Boolean,
            default: false
        },
        create: {
            type: Object
        },
        data: {
            type: Object
        },
        canEdit: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        data(to) {
            this.summary = to.info
        }
    },
    methods: {
        showCard(id, e) {
            console.log(123,id)
            if (id == 0) return;

            const el = e.target;

            this.$card(id, el);
        },
        closeMethod() {
            this.showMethod = false;
        },
        maskMaterial() {
            // this.$refs.mediaCenter.showMaterialListBox1('myMaterial', false).then(res => {
            //     // this.cover = res;
            //     // this.showMethod = false;
            //     console.log(res)
            // })
            // console.log(this.$router)
            this.showMethod = false;

            let config = {
                materialChannel: 'materialBin',
                showMore: false,
                onlyOne: true,
                create: this.create,
                quickEdit: this.quickEdit,
                link: this.newOpen
            }

            this.$materialListBox(config).then(res => {
                if (res) {
                    console.log(res)
                    this.cover = res.cover
                    this.file_id = res.id
                    this.saveUser()
                    // this.getFlashfile();
                    // console.log(res)
                    // return res
                    // // this.getFlashfile();
                }
            });
        },
        saveUser(path) {
            // 更新用户信息
            if(path){
                this.file_id = ''
            }else{
                path = ''
            }
            let info = {
                idstring: this.data.idstring,
                file_id: this.file_id,
                path: path
            }

            return common.myFetch(config.apis.setcover, info)
            .then(r => {
                if (r) {
                    console.log(r)
                    // this.cover = r.cover
                    return r
                }
            })
        },
        changeAvatar(p) {
            console.log(p)
            this.saveUser(p)
            .then((r) => {
                this.cover = r.cover
                this.$toast("修改成功");
                this.showMethod = false;
                // this.$emit('clickFun')
            })
        },
        setInfoMaterial() {
            let info = {
                idstring: this.data.idstring,
                info: this.summary
            };
            common.myFetch(config.apis.setInfoMaterial, info).then(r => {
                if (r) {
                    this.$toast("修改成功");
                    this.$emit('cahngeSummary',this.summary)
                }
            });
        },
        load() {
            // 加载js文件
            if (window.Stream) {
                return new Promise((r, j) => {r(true)})
            }

            return common.load(config.streamjs)
        },
        getConfig() {
            return common.getFileConfigs()
            .then(r => {
                this.baseUrl = r.url
                this.appId = r.app_id
                this.appSecret = r.app_secret

                const dataConfig = {
                    tokenURL: this.baseUrl + config.apis.File_get_token,
                    uploadURL: this.baseUrl + config.apis.File_post,
                    postVarsPerFile : {
                        appId: this.appId,
                        appSecret: this.appSecret
                    }
                }

                Object.assign(this.picConfig, dataConfig, common.userKeys())
                return true
            })
        },
        configUpload() {
            // 配置上传接口
            Promise.all([this.load(), this.getConfig(), this.getAsperaConfig()]).then(() => {
                this.picStream = new Stream(this.picConfig)
            })
        },
        getAsperaConfig() {
            // 获取aspera上传配置
            return common.myFetch(config.apis.File_Aspera)
            .then(r => {
                if (r) {
                    window._XN_upCfg = {
                        asperaPath: r.aspera_path,
                        httpPath: r.original_path,
                        fileNameId: r.filename_id
                    }

                    return true
                }
            })
        }
    },
    mounted() {
        this.summary = this.data.info
        this.configUpload();
        setTimeout(() => {
            this.cover = this.data.cover
        }, 500);
    }
}
</script>

<style lang="less" scoped>
    .detail-container {
        width: 100%;

        .changeBg {
            display: flex;
            flex-direction: row;
            margin: 14px 0 7px;
            padding: 0 20px;
            box-sizing: border-box;


            span {
                display: block;
                width: 52px;
                height: 18px;
                font-size: 13px;
                color: #829191;
                line-height: 18px;
                margin-right: 54px;
                text-align-last: justify;
                text-align: justify;
                font-weight: bold;
            }

            .bg {
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 142px;
                height: 80px;
                border-radius: 4px;
                background: rgba(0, 0, 0, 0.3);
                background-size: contain;
                background-position: center center;
                background-repeat: no-repeat;

                &:hover {
                    .change {
                        display: block;
                    }
                }

                .change {
                    display: none;
                    width: 40px;
                    height: 20px;
                    line-height: 20px;
                    text-align: center;
                    border-radius: 2px;
                    background: rgba(0,0,0,0.5);
                    font-size: 12px;
                    color: #FFFFFF;
                    user-select: none;
                    cursor: pointer;

                    &.on {
                        display: block;
                    }
                }

                ul {
                    position: absolute;
                    top: 54px;
                    left: 50%;
                    z-index: 1;
                    margin-left: -39px;
                    display: flex;
                    flex-direction: column;
                    width: 78px;
                    border-radius: 4px;
                    overflow: hidden;
                    padding: 5px 0;
                    background: rgba(0, 0, 0, 0.8);
                    box-sizing: border-box;

                    li {
                        width: 100%;
                        height: 27px;
                        line-height: 27px;
                        text-align: center;
                        font-size: 12px;
                        color: #FFFFFF;
                        font-weight: bold;
                        user-select: none;
                        cursor: pointer;

                        &:hover {
                            color: #41B48C;
                        }
                    }
                }
            }
        }

        .nameAndTime {
            position: relative;
            display: flex;
            justify-content: space-between;
            width: 100%;
            padding: 14px 20px;
            // border-bottom: 1px solid #F0F0F0;
            box-sizing: border-box;

            .name {
                display: flex;
                flex-direction: row;
                align-items: center;
                font-size: 14px;
                color: #41B48C;
                font-weight: bold;
                user-select: none;
                cursor: pointer;

                i {
                    display: block;
                    min-width: 18px;
                    min-height: 18px;
                    background: url('../../../common/newMaterialBox/assets/name.png') no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-right: 7px;
                }

                p {
                    max-width: 150px;
                    overflow: hidden;
                    white-space: nowrap;
	                text-overflow: ellipsis;
                }
            }

            .time {
                display: flex;
                flex-direction: row;
                align-items: center;
                font-size: 14px;
                color: #050F0F;
                font-weight: bold;

                i {
                    display: block;
                    width: 18px;
                    height: 18px;
                    background: url('../../../common/newMaterialBox/assets/clock.png') no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-right: 8px;
                }
            }
        }

        .line {
            width: 100%;
            padding: 0 20px;
            box-sizing: border-box;

            p {
                border-bottom: 1px solid #F0F0F0;
                box-sizing: border-box;
            }
        }

        .mediaDetail {
            padding: 14px 20px;
            box-sizing: border-box;

            &.bg {
                background: rgba(65, 180, 140, 0.04);
            }

            &.align {
                li {
                    position: relative;
                    align-items: flex-start;

                    p {
                        max-width: 266px;
                        height: 227px;
                        line-height: 20px;
                    }

                    i {
                        display: inline-block;
                        min-width: 22px;
                        min-height: 22px;
                        background: url('../../../common/newMaterialBox/assets/reName.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                        margin-left: 4px;
                        user-select: none;
                        cursor: pointer;
                        vertical-align: text-bottom;
                    }

                    .confirm {
                        position: absolute;
                        bottom: 10px;
                        right: 10px;
                        font-size: 14px;
                        color: #41b48c;
                        user-select: none;
                        cursor: pointer;
                    }
                }
            }

            &>li {
                display: flex;
                flex-direction: row;
                align-items: center;
                font-weight: bold;
                margin-bottom: 14px;

                &.b {
                    margin-bottom: 4px;
                }

                span {
                    &:nth-of-type(1) {
                        display: block;
                        width: 52px;
                        height: 18px;
                        font-size: 13px;
                        line-height: 18px;
                        color: #829191;
                        margin-right: 38px;
                        text-align-last: justify;
                        text-align: justify;
                        text-justify: distribute-all-lines;
                    }
                }

                p {
                    font-size: 14px;
                    line-height: 20px;
                    color: #050F0F;
                    word-wrap: break-word;
                }

                textarea {
                    width: 266px;
                    height: 227px;
                    border: none;
                    outline: none;
                    resize: none;
                    border: 1px solid #00B889;
                    padding: 10px;
                    box-sizing: border-box;
                }

                &:nth-last-of-type(1) {
                    margin-bottom: 0;
                }

                ul {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;

                    li {
                        font-size: 14px;
                        color: #0B131F;
                        height: 30px;
                        line-height: 30px;
                        border-radius: 4px;
                        background: rgba(185,195,195,0.2);
                        padding: 0 20px;
                        box-sizing: border-box;
                        // font-weight: normal;
                        margin: 0 10px 10px 0;

                        &.alert {
                            background: rgba(255,105,105,0.2);
                        }
                    }
                }
            }
        }
    }
</style>